import * as yup from 'yup';
import { Hero } from '../../components';
import { linkSchema, inlineRichTextFromCMSSchema } from '../schemas';
import { schema as flexibleImage } from './flexible_picture';

export const component = Hero;

export const schema = yup
  .object({
    headline: inlineRichTextFromCMSSchema,
    subheadline: yup.string().nullable(),
    link: linkSchema,
    image: flexibleImage,
    backgroundColor: yup.string(),
    fontColor: yup.string(),
    horizontalOrientation: yup.mixed().oneOf(['left', 'center', 'right']),
    buttonVariant: yup.string(),
  })
  .transform(value => ({
    headline: value.headline,
    subheadline: value.subheadline,
    link: value.link[0],
    image: value.image[0],
    // These need to fallback to `undefined`
    // so the defaults in the component kick in.
    // Otherwise, they're passed forward as empty strings.
    backgroundColor: value.background_color || undefined,
    fontColor: value.font_color || undefined,
    horizontalOrientation: value.horizontal_orientation,
    buttonVariant: value.button_variant || undefined,
  }));
